import React, { useRef } from 'react';
import { Animated, View, StyleSheet } from 'react-native';

import { useTheme } from './Theme';

const Indicator = ({index, current, color}) => {
  const opacity = current.interpolate({
    inputRange: [index - 1, index, index + 1],
    outputRange: [0.37, 1, 0.37],
    extrapolate: 'clamp'
  });
  const width = current.interpolate({
    inputRange: [index - 1, index, index + 1],
    outputRange: [DOT_DIAMETER, 3 * DOT_DIAMETER, DOT_DIAMETER],
    extrapolate: 'clamp'
  });

  return (
    <Animated.View
      style={[
        page_indicator_styles.dot,
        {
          backgroundColor: color,
          width,
          opacity
        }
      ]}
    />
  );
}

export const PageIndicator = ({
  count,
  current,
  color,
  ...props
}) => {
  const theme = useTheme();

  return (
    <View style={{flexDirection: 'row'}}>
      {
        [...new Array(count)].map((_, index) => (
          <Indicator
            key={index}
            index={index}
            current={current}
            count={count}
            color={color}
          />
        ))
      }
    </View>
  );
};

const DOT_DIAMETER = 6;
export const PAGE_INDICATOR_HEIGHT = 2 * DOT_DIAMETER;
const page_indicator_styles = StyleSheet.create({
  dot: {
    margin: 0.5 * DOT_DIAMETER,
    borderRadius: 0.5 * DOT_DIAMETER,
    width: DOT_DIAMETER,
    height: DOT_DIAMETER
  }
})

